import React, { useCallback, useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";

function defaultGetOptionValue(option) {
  return option?.id ?? "";
}

export function SearchableSelectField({
  label,
  options,
  value,
  onChange,
  getOptionLabel,
  getOptionValue = defaultGetOptionValue,
  getSearchText,
  placeholder,
  noOptionsText = "No matches found"
}) {
  const selectedOption = useMemo(() => {
    if (value === "" || value == null) return null;
    return options.find((option) => String(getOptionValue(option)) === String(value)) ?? null;
  }, [getOptionValue, options, value]);

  const filterOptions = useCallback(
    (availableOptions, state) => {
      const query = String(state.inputValue ?? "")
        .trim()
        .toLowerCase();

      if (!query) return availableOptions;

      const terms = query.split(/\s+/).filter(Boolean);

      return availableOptions.filter((option) => {
        const searchableText = [getOptionLabel(option), getOptionValue(option), getSearchText?.(option)]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();

        return terms.every((term) => searchableText.includes(term));
      });
    },
    [getOptionLabel, getOptionValue, getSearchText]
  );

  return (
    <div className="field searchable-select-field">
      <span>{label}</span>
      <Autocomplete
        className="searchable-select"
        options={options}
        value={selectedOption}
        fullWidth
        openOnFocus
        autoHighlight
        selectOnFocus
        clearOnEscape
        handleHomeEndKeys
        noOptionsText={noOptionsText}
        filterOptions={filterOptions}
        getOptionLabel={(option) => getOptionLabel(option) || ""}
        isOptionEqualToValue={(option, selected) => String(getOptionValue(option)) === String(getOptionValue(selected))}
        onChange={(_event, nextOption) => onChange(nextOption ? getOptionValue(nextOption) : "")}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            placeholder={placeholder}
          />
        )}
      />
    </div>
  );
}
